import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";
import { ProcurementAxios } from "api/ProcurementAxios";
import { DistrictInChargeAxios } from "api/DistrictInChargeAxios";

const API_URL = process.env.REACT_APP_BASE_URL;
const TOKEN = "a94c7ac0083ae190f0fe61143a7547799b5334c4";

const headers = {
  Authorization: `Token ${TOKEN}`,
  "Content-Type": "application/json",
};

export const AssignTaskList = createAsyncThunk(
  "assigned_task/AssignTaskList",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }
    if (filters && filters.length > 0) {
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (
            filterField &&
            filterValue !== undefined &&
            filterValue !== null
          ) {
            if (typeof filterValue === "object" && filterValue !== null) {
              // Handle cases like { from_date: ..., to_date: ... }
              Object.entries(filterValue).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                  params.append(key, String(value));
                }
                if (
                  (filterValue.from_date || filterValue.to_date) &&
                  (filterField === "created_at" || filterField === "updated_at")
                ) {
                  if (filterField === "created_at") {
                    filterField = "created";
                  } else {
                    filterField = "updated";
                  }
                  params.append("filter_by", filterField);
                }
              });
            } else {
              // Handle primitive values (string, number)
              params.append(filterField, filterValue);
            }
          }
        }
      );
    }

    // const response: any = await axios.get(`https://3jg09h9h-8020.inc1.devtunnels.ms/api/task-list/assign-task-list/?${params.toString()}`);
    const response: any = await DistrictInChargeAxios.get(
      `/task-list/assign-task-list/?${params.toString()}`
    );

    return {
      // data: response?.data || [],
      data: response?.data?.data || [],
      rowCount: response?.count || 0,
    };
    //console.log(data,"data---------------54")
  }
);

export const AssignTaskListExport = createAsyncThunk(
  "assigned_task/AssignTaskListExport ",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "*/*",
      };
      const response = await ProcurementAxios.get(
        "/approved-pr/list/?export=csv",
        {
          headers,
          responseType: "blob",
        }
      );
      return {
        blob: response.data,
        filename:
          response.headers["content-disposition"]
            ?.split("filename=")[1]
            ?.replace(/"/g, "") || "Aproved PR.csv",
      };
    } catch (err: any) {
      console.error("Export CSV error:", err);
      return rejectWithValue(err.message || "Failed to export CSV");
    }
  }
);

//   "suppliers/fetchAllDropdownsFieldEngineer",
//   async (column: string, { rejectWithValue }) => {
//     try {
//       const response = await Axios.get(
//         `purchase_request/dropdown/`,
//         { params: { columns: column } }
//       );

//       const dropdownData = response.data?.data || response.data || [];

//       console.log("Dropdown API response:", dropdownData);

//       return { column, data: dropdownData };
//     } catch (err: any) {
//       return rejectWithValue(err.response?.data || 'Failed to fetch dropdown');
//     }
//   }
// );
